<template>
  <div class="menu_box border_bottom_dashed" v-if="name">
    <div class="flex paddingAll20">
      <div class="title_shaixuan flex_jc_center">{{ name }}</div>
      <div class="classified_content" :style="show?'height:auto;margin-bottom:10px':'height:46px'" ref="height">
        <div class="unfold flex_ai_center" :class="show?'unfold-red':''" @click="show=!show" v-if="height">
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
        <span v-for="(item, index) in data" :key="index" :class="{ pitch_on: teamIndex==index }"
              @click="send(item, index)">
            {{ item.name }}
          </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "row",
  data() {
    return {
      show: true,
      height: false,
    }
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    name: {type: String},
    teamIndex: {type: [String, Number]},
  },
  mounted() {
    this.$nextTick(v => {
      this.height = this.$refs.height.offsetHeight > 46
      this.show = !this.height
    })
  },
  watch: {
    data() {
      this.$nextTick(v => {
        this.height = this.$refs.height.offsetHeight > 46
        this.show = !this.height
      })
    }
  },
  methods: {
    /** @name 搜索单项 */
    send(obj, key) {
      this.$emit('update:teamIndex', key)
      this.$parent.send(this.name)
    },
  },
}
</script>

<style scoped>

</style>
